export default "__VITE_ASSET__DjmsFo6n__"